import script from "./WegowChat.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowChat.vue?vue&type=script&setup=true&lang=js"

import "./WegowChat.vue?vue&type=style&index=0&id=2ef261e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef261e0"]])

export default __exports__